import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"



interface Props {
  title: string;
  maxWidth?: string;
  contentClass?: string;
  actionsClass?: string;
  hideActions?: boolean;
  persistant?: boolean;
  loading?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'BaseDialog',
  props: /*#__PURE__*/_mergeModels({
    title: {},
    maxWidth: { default: "500" },
    contentClass: { default: "pa-4" },
    actionsClass: { default: "py-0 px-4" },
    hideActions: { type: Boolean, default: false },
    persistant: { type: Boolean, default: false },
    loading: { type: Boolean, default: false }
  }, {
    "modelValue": { type: Boolean },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const model = _useModel<boolean>(__props, "modelValue");

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: model.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((model).value = $event)),
    "max-width": _ctx.maxWidth,
    scrollable: "",
    persistant: _ctx.persistant
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "pa-0" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_toolbar, {
                color: "primary",
                flat: "",
                density: "compact"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_toolbar_title, { class: "toolbar" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.title), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_spacer),
                  _renderSlot(_ctx.$slots, "toolbar-actions"),
                  _createVNode(_component_v_btn, {
                    icon: "mdi-close",
                    disabled: _ctx.loading,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (model.value = false))
                  }, null, 8, ["disabled"])
                ]),
                _: 3
              })
            ]),
            _: 3
          }),
          _createVNode(_component_v_card_text, {
            class: _normalizeClass(_ctx.contentClass)
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          }, 8, ["class"]),
          (!!_ctx.$slots.actions && !_ctx.hideActions)
            ? (_openBlock(), _createBlock(_component_v_card_actions, {
                key: 0,
                class: _normalizeClass(_ctx.actionsClass)
              }, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "actions")
                ]),
                _: 3
              }, 8, ["class"]))
            : _createCommentVNode("", true)
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["modelValue", "max-width", "persistant"]))
}
}

})